<template>
    <HendBtn></HendBtn>
    <router-view />
    <Footer></Footer>
</template>

<script setup>
import HendBtn from './components/HendBtn.vue'
import Footer from './components/Footer.vue'
import { useStore } from 'vuex'
import { onMounted } from 'vue'
import 'vant/lib/index.css'; //引入样式
const store = useStore()
store.dispatch('getHomeConfigData');


let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
onMounted(() => {
    if (flag) {//是否在移动端打开
        pxToRem();
    }
})

// 转换
function pxToRem() {
    //设计稿的宽度
    let psdWidth = 750;
    //预设字体值,浏览器默认
    let preFontSize = 16;
    //当前屏幕宽度
    let curScreenWidth = document.documentElement.clientWidth;
    //当前屏幕对应的html字体值
    let curFontSize = (curScreenWidth * preFontSize) / psdWidth;
    //设备宽度在750px 
    if (curScreenWidth > 750) {
        curScreenWidth = 750;
    }
    //把计算下来的当前屏幕html字体值 赋值给html元素 documentElement属性会获取到html根元素 然后为之设置字体值
    document.querySelector('html').style.fontSize = curFontSize + "px";
}




</script>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

a {
    color: #ffffff;
    text-decoration: none;
}



@font-face {
    font-family: "Source Han Sans CN";
    src: url("./assets/text/Source Han Sans CN.OTF");
    font-weight: normal;
    font-style: normal;
}
</style>
